import { zodResolver } from '@hookform/resolvers/zod';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useCurrentUser, useUpdateUserDetails } from 'src/hooks';
import { z } from 'zod';

// TODO: proper validation
const schema = z.object({
  phoneNumber: z.string().min(1, 'Phone number is required'),
  title: z.string().min(1),
  department: z.string().min(1),
  roomNumber: z.string().min(1),
  budgetCode: z.string().min(1),
  shippingAddress: z.string().min(1),
});

type UserDetailsSchema = z.infer<typeof schema>;

export const UserDetails = () => {
  const { user } = useCurrentUser();
  const { t } = useTranslation();

  const updateUserDetails = useUpdateUserDetails();

  const {
    control,
    register,
    formState: { errors },
  } = useForm<UserDetailsSchema>({
    resolver: zodResolver(schema),
    defaultValues: {
      phoneNumber: user!.accountDetails?.phoneNumber ?? '',
      title: user!.accountDetails?.title ?? '',
      department: user!.accountDetails?.department ?? '',
      roomNumber: user!.accountDetails?.roomNumber ?? '',
      budgetCode: user!.accountDetails?.budgetCode ?? '',
      // shippingAddress: user!.accountDetails?.shippingAddress ?? '',
    },
  });

  const disbaleInputs = updateUserDetails.isPending;

  // TODO: add necessary form fields / error handling / submission
  return (
    <>
      {user && user.subscription.tier === 'organization' && (
        <>
          <div className='flex w-full flex-col items-start justify-center gap-1 md:gap-2'>
            <h5 className='heading-100'>{t('my_account.phone_number')}</h5>
            <Controller
              name='phoneNumber'
              control={control}
              render={({ field: { onChange, value } }) => (
                <PhoneInput
                  value={value}
                  onChange={onChange}
                  defaultCountry='US'
                  countryCallingCodeEditable={false}
                  className='w-full'
                  disabled={disbaleInputs}
                />
              )}
            />
            {errors.phoneNumber && (
              <span className='text-sm text-red-500'>
                {errors.phoneNumber.message}
              </span>
            )}
          </div>

          <div className='flex w-full flex-col items-start justify-center gap-1 md:gap-2'>
            <h5 className='heading-100'>{t('my_account.title')}</h5>
            <input
              {...register('title')}
              disabled={disbaleInputs}
              type='text'
              className={`flex h-12 w-full items-center rounded border-none bg-cloudGray p-2 pr-8 font-secondary text-base font-semibold uppercase text-primary-dark outline-none ring-2 ring-transparent transition-all selection:bg-primary selection:text-cloudGray placeholder:font-normal placeholder:normal-case placeholder:text-[#636E7A] hover:bg-gray-200 focus:bg-cloudGray focus:ring-2 focus:ring-primary
          hover:focus:bg-cloudGray`}
            />
            {errors.title && (
              <span className='text-sm text-red-500'>
                {errors.title.message}
              </span>
            )}
          </div>

          <div className='flex w-full flex-col items-start justify-center gap-1 md:gap-2'>
            <h5 className='heading-100'>{t('my_account.department')}</h5>
            <input
              {...register('department')}
              disabled={disbaleInputs}
              type='text'
              className={`flex h-12 w-full items-center rounded border-none bg-cloudGray p-2 pr-8 font-secondary text-base font-semibold uppercase text-primary-dark outline-none ring-2 ring-transparent transition-all selection:bg-primary selection:text-cloudGray placeholder:font-normal placeholder:normal-case placeholder:text-[#636E7A] hover:bg-gray-200 focus:bg-cloudGray focus:ring-2 focus:ring-primary
          hover:focus:bg-cloudGray`}
            />
            {errors.department && (
              <span className='text-sm text-red-500'>
                {errors.department.message}
              </span>
            )}
          </div>

          <div className='flex w-full flex-col items-start justify-center gap-1 md:gap-2'>
            <h5 className='heading-100'>{t('my_account.room_number')}</h5>
            <input
              {...register('roomNumber')}
              disabled={disbaleInputs}
              type='text'
              className={`flex h-12 w-full items-center rounded border-none bg-cloudGray p-2 pr-8 font-secondary text-base font-semibold uppercase text-primary-dark outline-none ring-2 ring-transparent transition-all selection:bg-primary selection:text-cloudGray placeholder:font-normal placeholder:normal-case placeholder:text-[#636E7A] hover:bg-gray-200 focus:bg-cloudGray focus:ring-2 focus:ring-primary
          hover:focus:bg-cloudGray`}
            />
            {errors.roomNumber && (
              <span className='text-sm text-red-500'>
                {errors.roomNumber.message}
              </span>
            )}
          </div>

          <div className='flex w-full flex-col items-start justify-center gap-1 md:gap-2'>
            <h5 className='heading-100'>{t('my_account.budget_code')}</h5>
            <input
              {...register('budgetCode')}
              disabled={disbaleInputs}
              type='text'
              className={`flex h-12 w-full items-center rounded border-none bg-cloudGray p-2 pr-8 font-secondary text-base font-semibold uppercase text-primary-dark outline-none ring-2 ring-transparent transition-all selection:bg-primary selection:text-cloudGray placeholder:font-normal placeholder:normal-case placeholder:text-[#636E7A] hover:bg-gray-200 focus:bg-cloudGray focus:ring-2 focus:ring-primary
          hover:focus:bg-cloudGray`}
            />
            {errors.budgetCode && (
              <span className='text-sm text-red-500'>
                {errors.budgetCode.message}
              </span>
            )}
          </div>

          <div className='flex w-full flex-col items-start justify-center gap-1 md:gap-2'>
            <h5 className='heading-100'>{t('my_account.shipping_address')}</h5>
            <input
              {...register('shippingAddress')}
              disabled={disbaleInputs}
              type='text'
              className={`flex h-12 w-full items-center rounded border-none bg-cloudGray p-2 pr-8 font-secondary text-base font-semibold uppercase text-primary-dark outline-none ring-2 ring-transparent transition-all selection:bg-primary selection:text-cloudGray placeholder:font-normal placeholder:normal-case placeholder:text-[#636E7A] hover:bg-gray-200 focus:bg-cloudGray focus:ring-2 focus:ring-primary
          hover:focus:bg-cloudGray`}
            />
          </div>
        </>
      )}
      {/* <div className='flex w-full flex-col items-start justify-center gap-1 md:gap-2'>
        <h5 className='heading-100'>{t('my_account.username')}</h5>
        <input
          disabled={true}
          type='text'
          placeholder={t('common.coming_soon')}
          className={`flex h-12 w-full items-center rounded border-none bg-cloudGray p-2 pr-8 font-secondary text-base font-semibold uppercase text-primary-dark outline-none ring-2 ring-transparent transition-all selection:bg-primary selection:text-cloudGray placeholder:font-normal placeholder:normal-case placeholder:text-[#636E7A] hover:bg-gray-200 focus:bg-cloudGray focus:ring-2 focus:ring-primary
      hover:focus:bg-cloudGray`}
        />
      </div>

      <div className='flex w-full flex-col items-start justify-center gap-1 md:gap-2'>
        <h5 className='heading-100'>{t('my_account.personal_bio')}</h5>
        <textarea
          name='cart-note'
          cols={60}
          rows={3}
          maxLength={150}
          placeholder={t('common.coming_soon')}
          disabled={true}
          className='w-full resize-none rounded border-none bg-cloudGray px-3 py-4 font-secondary font-semibold leading-[24px] text-primary-dark outline-none transition-all selection:bg-primary selection:text-offWhite placeholder:font-normal placeholder:text-[#636E7A] hover:bg-gray-200 focus:ring-2 focus:ring-primary hover:focus:bg-offWhite'
        />
        <span className='text-100 w-full text-right'>0 / 150</span>
      </div> */}
    </>
  );
};
